<template>
  <div>
    <img v-if="hasLogo" class="team-logo" :height="height" :width="width" :src="teamLogo"/>

    <placeholder-avatar v-else :initials="initials" :height="height" :width="width"/>
  </div>
</template>

<script>
  import PlaceholderAvatar from './PlaceholderAvatar.vue'
  import imageMixin from 'src/utils/mixins/image'

  export default {
    props: {
      team: {
        type: Object,
        required: true
      },

      height: {
        type: String,
        default: '36px'
      },

      width: {
        type: String,
        default: '36px'
      }
    },

    computed: {
      hasLogo () {
        return this.team.settings.logo_url
      },

      teamLogo () {
        return this.hasLogo ? this.getImageUrl(this.team.settings.logo_url, 'small') : null
      },

      initials () {
        return this.team.name.split(' ').slice(0, 2).map(str => str.charAt(0)).join('').toUpperCase()
      }
    },

    mixins: [
      imageMixin
    ],

    components: {
      PlaceholderAvatar
    }
  }
</script>

<style lang="stylus">
  .team-logo
    border-radius: 50%
    object-fit: contain
</style>
